import { render, staticRenderFns } from "./configCreate.vue?vue&type=template&id=011292b1&scoped=true&"
import script from "./configCreate.vue?vue&type=script&lang=js&"
export * from "./configCreate.vue?vue&type=script&lang=js&"
import style0 from "./configCreate.vue?vue&type=style&index=0&id=011292b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011292b1",
  null
  
)

export default component.exports